import { render, staticRenderFns } from "./EditablePostbackProtocol.vue?vue&type=template&id=b2db12e4"
import script from "./EditablePostbackProtocol.vue?vue&type=script&lang=js"
export * from "./EditablePostbackProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports